<template>
    <v-card class="rounded-4"> 
        <v-toolbar flat height="45px">  
            <b>De Minimis Threshold Summary</b>
            <v-spacer></v-spacer>  
            <v-btn icon @click.native="closeDialog()" >
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="thresholdList"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="paginationSync"
            :hide-headers="isMobile"
            :hide-actions="thresholdList.length<6"
        >
            <template v-slot:items="props">

                <!-- mobile view -->
                <tr v-if="isMobile">
                     <td :colspan="headers.length" class="pa-1">   
                        <v-card class="rounded-5">
                            <v-toolbar flat height="40" class="transparent">
                                <v-chip small>{{props.item.fiscalYear}}</v-chip>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-layout row wrap align-center class="section-layout">
                                <v-flex xs12 class="text-xs-left mt-5">
                                    <v-layout row>
                                        <v-flex xs6>
                                            <div class="caption grey--text text--darken-1">Type</div>
                                            <div>{{ props.item.deminimisName }}</div>
                                        </v-flex>
                                        <v-flex xs6>
                                            <div class="caption grey--text text--darken-1">Annual Amount</div>
                                            <div>{{ numFormat.formatNumber(props.item.annualAmount) }}</div>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs6>
                                            <div class="caption grey--text text--darken-1">Annual Threshold</div>
                                            <div>{{ numFormat.formatNumber(props.item.annualThreshold) }}</div>
                                        </v-flex>
                                        <v-flex xs6>
                                            <div class="caption grey--text text--darken-1">Annual Excess</div>
                                            <div v-if="props.item.annualExcess" class="warning--text">{{ numFormat.formatNumber(props.item.annualExcess) }}</div>
                                            <div v-else class="green--text">{{ numFormat.formatNumber(props.item.annualExcess) }}</div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </td>
                </tr>


                <!-- desktop view -->
                <tr v-else>
                    <td>{{ props.item.fiscalYear }}</td>
                    <td>{{ props.item.deminimisName }}</td>
                    <td class="text-xs-right">
                        {{ numFormat.formatNumber(props.item.annualAmount) }}
                    </td>
                    <td class="text-xs-right">
                        {{ numFormat.formatNumber(props.item.annualThreshold) }}
                    </td>
                    <td class="text-xs-right">
                        <span v-if="props.item.annualExcess" class="warning--text">{{ numFormat.formatNumber(props.item.annualExcess) }}</span>
                        <span v-else class="green--text">{{ numFormat.formatNumber(props.item.annualExcess) }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>

import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import numFormat from '@/common/num_format'

export default {
    data () {
        const routeName = `${this.$route.name}-threshold-summary`
        const savedSort = userPrefs.getSort(routeName)
        
        return {
            numFormat,
            rowsPerPageItems,
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            search: userPrefs.getSearchKeyword(routeName),
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Year',align:'left',value:'fiscalYear',width: '5%', sortable:true},
                {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Annual Threshold',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Annual Excess',align: 'right',value: '',width: '5%', sortable:false},
            ],
            time_reports: []
        }   
    },
    props: ['data'],
    methods: {
        closeDialog() {
            this.$emit('update:dialogThresholdSummary', false)
        },
    },
    created() {},
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-threshold-summary`, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-threshold-summary`, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-threshold-summary`, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(t`${this.$route.name}-threshold-summary`, newVal)
        }
    },
    computed: {
        thresholdList() {
            return this.data
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:5px 23px 5px 23px;
}
</style>